import { type Clip } from '@air/api/types';

import { ClipUtils } from './ClipUtils';

export const getAssetIsTranscoded = (asset?: { status?: Clip['status'] | null }) =>
  asset && ClipUtils.isTranscoded(asset.status);
